import { PaginaNode } from '@gql/graphql'
import useTrans from '@hooks/useTrans'
import { PlaceholderReact } from '@components/molecules'
import { CardSwiper, GenericHero, Page, Prefooter } from 'components/organisms'
import styles from './SostenibilitaDetailTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
  paginaParent?: PaginaNode
}

const SostenibilitaDetailTemplate = (props: Props) => {
  const { pagina = undefined, paginaParent = undefined } = props

  const t = useTrans()
  const defaultContent1 = pagina?.pagebuilders?.find((x) => x.key === 'main') ?? null

  const correlatiItem = {
    name: t('Sostenibilità'),
    ctaLabel: t('Scopri di più sulla Sostenibilità'),
    url: paginaParent?.url,
    children: paginaParent?.menuChildren
      ? paginaParent.menuChildren
          .filter((x) => x.pk !== pagina.pk)
          .map((x) => ({
            ...x,
            name: x.nome,
            description: x.descrizione,
            image: x.previewImage,
          }))
      : [],
  }

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero pagina={pagina} />
        <div className={styles.placeholderContent}>
          <PlaceholderReact
            contentTypeId={pagina.model}
            objectId={pagina.pk}
            pkey={'main'}
            serverSideContent={defaultContent1}
          />
        </div>
        <CardSwiper
          id="sostenibilita-correlati-swiper"
          item={correlatiItem}
          theme="neutral10"
          size="md"
        />
        <Prefooter />
      </main>
    </Page>
  )
}

export default SostenibilitaDetailTemplate
